
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/products/shopping",
      function () {
        return require("private-next-pages/products/shopping/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/products/shopping"])
      });
    }
  